/** @format */

export interface IIncludeType {
  body: string;
  footer: string;
  meta: string;
}

export interface IPageType {
  category?: string;
  product?: string;
}

export interface ISearchDex {
  includeType: IIncludeType;
  pageType: IPageType;
}

export interface IFooterData {
  copyright: string;
  oracleChat: string;
  social: Record<string, string>;
}

export interface IPreferenceIds {
  nfl: number;
  brand: number;
  color: number;
  size: number;
}

export interface IFooterLinks {
  text: string;
  link: string;
}
export interface IChain {
  aemData: {
    subText: string;
    title: string;
  };
  apiVersion: number;
  auth0: {
    enabled: boolean;
  };
  authStrategy: string;
  bopisFlag: boolean;
  bopisLocationDefault?: number;
  cartTitle: string;
  cartUrlParameters: string;
  catalogIdCollections: string;
  catalogIdContent: string;
  catalogIdSales: string;
  chainBopisIcon: string;
  chainCartImage: string | boolean;
  chainCartUrl: string;
  chainFooterUrls: Record<string, IFooterLinks | null>;
  chainIdentifier: string;
  chainIdentifierAbbr: string;
  chainIdentifierCookie?: string;
  chainIdentifierCookieAOS?: string;
  chainInitial: string;
  chainMarketingIdentifierAbbr: string;
  chainName: string;
  chatUrl: string;
  checkoutConfirmationUrlParameters?: string;
  checkoutUrlBase: string;
  checkoutUrlParameters: string;
  crossChainBopisPartners?: string[];
  crossChainLogoSVG?: string | Record<string, string>;
  crossChainLogoSVGV2?: string;
  feedbackSurveyId: string;
  footerData: IFooterData;
  holidayOfferCode: string;
  isaFlag: boolean;
  logoSVG?: string;
  logoSVGV2?: string;
  masterCatalogId: string;
  metaCanonical: string;
  metaCanonicalHost: string;
  metaDescription: string;
  metaTitle: string;
  myAccountUrlAuthListSignIn: string;
  myAccountUrlLoggedIn: string;
  myAccountUrlLoggedOut: string;
  nestjsProductAPIVersion: string;
  partyServiceId?: number;
  preferenceIds?: IPreferenceIds;
  priceStringIndicator: string;
  proTipsFlag: boolean;
  productAPIVersion: string;
  qAndAFlag: boolean;
  rewards: {
    image: string;
    programName: string;
  };
  rewardsAccountImage: string;
  rewardsAccountName: string;
  searchDex: ISearchDex;
  seoIdentifier: string;
  serviceIdentifier: string;
  serviceIdentifierAbbr: string;
  sessionCamIdentifier: string;
  shippingIcon?: string;
  shippingInfoIcon?: string;
  simpleHeaderLogoUrl: string;
  sizeChartSurveyId: string;
  storeId: string;
  supportNumber: string;
  userRegistrationFormUrl: string;
  vhHeader: string;
  xChannel: string;
}

export class Chain implements IChain {
  declare aemData: {
    subText: string;
    title: string;
  };

  declare authStrategy: string;
  declare bopisLocationDefault: number;
  declare catalogIdCollections: string;
  declare catalogIdContent: string;
  declare catalogIdSales: string;
  declare chainIdentifier: string;
  declare chainIdentifierAbbr: string;
  declare chainMarketingIdentifierAbbr: string;
  declare chainIdentifierCookie?: string;
  declare chainIdentifierCookieAOS?: string;
  declare chainInitial: string;
  declare chainName: string;
  declare chainCartImage: string | boolean;
  declare chainCartUrl: string;
  declare chainBopisIcon: string;
  declare chatUrl: string;
  declare holidayOfferCode: string;
  declare masterCatalogId: string;
  declare metaCanonical: string;
  declare metaCanonicalHost: string;
  declare metaDescription: string;
  declare metaTitle: string;
  declare myAccountUrlAuthListSignIn: string;
  declare myAccountUrlLoggedIn: string;
  declare myAccountUrlLoggedOut: string;
  declare nestjsProductAPIVersion: string;
  declare priceStringIndicator: string;
  declare serviceIdentifier: string;
  declare serviceIdentifierAbbr: string;
  declare shippingIcon: string;
  declare shippingInfoIcon: string;
  declare storeId: string;
  declare bopisFlag: boolean;
  declare isaFlag: boolean;
  declare qAndAFlag: boolean;
  declare partyServiceId?: number;
  declare preferenceIds?: IPreferenceIds;
  declare proTipsFlag: boolean;
  declare productAPIVersion: string;
  declare rewardsAccountName: string;
  declare rewardsAccountImage: string;
  declare searchDex: ISearchDex;
  declare cartUrlParameters: string;
  declare checkoutUrlBase: string;
  declare checkoutUrlParameters: string;
  declare checkoutConfirmationUrlParameters: string;
  declare userRegistrationFormUrl: string;
  declare sessionCamIdentifier: string;
  declare footerData: IFooterData;
  declare feedbackSurveyId: string;
  declare sizeChartSurveyId: string;
  declare cartTitle: string;
  declare crossChainBopisPartners?: string[];
  declare crossChainLogoSVG?: string | Record<string, string>;
  declare logoSVG?: string;
  declare vhHeader: string;
  declare chainFooterUrls: Record<string, IFooterLinks | null>;
  declare apiVersion: number;
  declare auth0: {
    enabled: boolean;
  };

  declare seoIdentifier: string;
  declare rewards: {
    image: string;
    programName: string;
  };

  declare xChannel: string;
  declare supportNumber: string;
  declare simpleHeaderLogoUrl: string;
}
